import React from "react";
import ErrorDiv from "./ErrorDiv";


/**
 *
 *
 * 12.11.25 - JA - Modified the full SmartErrorDiv component to be able to accept the following:
 *
 * sectionName = {'profile'}, name = {'firstname'} OR sectionName = {'profile.home'}, name = {'postcode'}
 *
 * Basically it now supports nested hook form definitions as long as the nesting is passed in as the section whilst maintaining old functionality
 *
 * @param sectionName
 * @param name
 * @param formErrors
 * @param maxLength
 */
const SmartErrorDiv = ({ sectionName, name, formErrors, maxLength }) => {

    const getNestedError = (path, errors) => {
        if (!path || !errors)
        {
            return undefined;
        }

        const keys = path.split(".");

        let current = errors;

        for (const key of keys)
        {
            if (current[key] === undefined)
            {
                return undefined;
            }

            current = current[key];
        }

        return current[name];
    };

    const error = getNestedError(sectionName, formErrors);

    if (error === undefined) {
        return null;
    }

    const { type, message } = error;

    if (type === "maxLength")
    {
        return <ErrorDiv>{`Please enter up to ${maxLength} characters`}</ErrorDiv>;
    }
    else if (type === "required")
    {
        return <ErrorDiv>Please enter a value</ErrorDiv>;
    }
    else if (["fileSize", "fileType", "validate", "pattern"].includes(type))
    {
        return <ErrorDiv>{message}</ErrorDiv>;
    }
    else
    {
        return <ErrorDiv>Invalid Input</ErrorDiv>;
    }
};

export { SmartErrorDiv };
